import { useState } from "react";
import "./Category.css";
import SideModal from "./SideModal";

function Category() {
  const [categories, setCategories] = useState([
    { id: 1, name: "Electronics" },
    { id: 2, name: "Fashion" },
  ]);

  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);

  const saveCategory = () => {
    if (!name.trim()) return;

    if (editId) {
      setCategories(
        categories.map((item) =>
          item.id === editId ? { ...item, name } : item
        )
      );
    } else {
      setCategories([
        ...categories,
        {
          id: Date.now(),
          name,
        },
      ]);
    }

    setName("");
    setEditId(null);
    setOpen(false);
  };

  const editCategory = (item) => {
    setName(item.name);
    setEditId(item.id);
    setOpen(true);
  };

  const deleteCategory = (id) => {
    setCategories(categories.filter((item) => item.id !== id));
  };

  return (
    <div className="page">

      <div className="topBar">
        <h2>Category Management</h2>

        <button
          className="addBtn"
          onClick={() => {
            setName("");
            setEditId(null);
            setOpen(true);
          }}
        >
          + Add Category
        </button>
      </div>

      <table>

        <thead>
          <tr>
            <th>#</th>
            <th>Category</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>

          {categories.map((item, index) => (

            <tr key={item.id}>
              <td>{index + 1}</td>

              <td>{item.name}</td>

              <td>

                <button
                  className="edit"
                  onClick={() => editCategory(item)}
                >
                  Edit
                </button>

                <button
                  className="Catdelete"
                  onClick={() => deleteCategory(item.id)}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

      <SideModal open={open} close={() => setOpen(false)}>

        <h3>{editId ? "Edit Category" : "Add Category"}</h3>

        <input
          type="text"
          placeholder="Category Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <button className="saveBtn" onClick={saveCategory}>
          Save
        </button>

      </SideModal>

    </div>
  );
}

export default Category;